import { tokens } from "../../../../../theme";

/**
 * The pills on a "waiting on you" row.
 *
 * Two tones only, and they mean different things: warning is a clock running,
 * danger is something that will not happen at all unless it is fixed. The book
 * uses them for "3 days left" and "Blocking" respectively.
 *
 * Kept out of the dashboard component so the date arithmetic can be tested on
 * its own — it is the part most likely to be quietly wrong.
 */
export const PILL_WARNING = { bg: tokens.warningTint, fg: tokens.warningText };
export const PILL_DANGER = { bg: tokens.dangerTint, fg: tokens.danger };

/**
 * Whole calendar days from today to `date`.
 *
 * Normalised to midnight at both ends: "is the pay date today" is a calendar
 * question, not an elapsed-time one, and a date eight hours away must not
 * arrive as a fraction of a day.
 */
export const daysUntil = (date) => {
  if (!date) return null;
  const then = new Date(date);
  if (Number.isNaN(then.getTime())) return null;
  const midnight = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  return Math.round((midnight(then) - midnight(new Date())) / 86400000);
};

/**
 * A deadline is only news when it is close.
 *
 * Nothing is shown for a pay date three weeks out: a pill that is always
 * present is a pill nobody reads, and the whole point of this one is that its
 * appearance means something.
 */
export const deadlinePill = (payDate) => {
  const d = daysUntil(payDate);
  if (d == null) return null;
  if (d < 0) return { pill: "Overdue", pillTone: PILL_DANGER };
  if (d === 0) return { pill: "Due today", pillTone: PILL_DANGER };
  if (d <= 5) return { pill: `${d} day${d === 1 ? "" : "s"} left`, pillTone: PILL_WARNING };
  return null;
};
